export default __webpack_public_path__ + "static/media/doc-admin-view.c592a240.svg";